import React, {Component, Fragment} from 'react';
import Select, {components} from 'react-select';
import {classNamesPrefixed} from '../../../helpers/CoreHelpers';
import InputWrap from "./InputWrap";
import Collapsible from "react-collapsible";
import {collapsibleSettings, getMenuItemsRecursive} from "../../helpers/Helpers";
import {connect} from 'react-redux';
import {get} from '../../store/actions/menu';
import _ from 'lodash';

const SingleValue = ({children, ...props}) => {
    if (props.selectProps.menuIsOpen) {
        return (
            <components.SingleValue {...props}/>
        );
    } else {
        return (
            <components.SingleValue {...props}>
                {children}
            </components.SingleValue>
        );
    }
};

class MenuField extends Component {
    componentDidMount() {
        const {get, routeParams: {workspace}, language: {current}} = this.props;


        get(workspace, current, true);
    }

    render() {
        const props = this.props;

        let defaultItem = null;
        let items = getMenuItemsRecursive({menu: props.menu});

        const {input, clearable, defaultValue, afterOnChange, afterOnChangeObject, placeholder, omitCollapsible, expanded} = props;
        const label = 'Select menu';

        if (input && input.value) {
            const item = _.find(items, {id: input.value});

            if (item) {
                defaultItem = {
                    id: item.id,
                    title: item.title
                };
            }
        }

        let inputWrapProps = {
            ...props,
            error: props && props.meta && props.meta.error ? props.meta.error : false,
            type: "select",

        };

        let onInputChange = input ? input.onChange : null;

        const content = (
            <InputWrap {...inputWrapProps}>
                <Select
                    classNamePrefix={classNamesPrefixed({
                        'custom-select': true
                    })}
                    value={defaultItem ? defaultItem : defaultValue}
                    isDisabled={false}
                    isLoading={false}
                    isClearable={clearable ? clearable : false}
                    isRtl={false}
                    isSearchable={true}
                    options={items}
                    components={{SingleValue}}
                    getOptionValue={(option) => (option.id)}
                    getOptionLabel={(option) => (option.title)}
                    placeholder={placeholder}
                    onChange={(value) => {
                        if (value && value.id) {
                            if (onInputChange) {
                                onInputChange(value.id);
                            }

                            if (afterOnChange) {
                                afterOnChange(value.id);
                            }

                            if (afterOnChangeObject) {
                                afterOnChangeObject(value);
                            }
                        } else {
                            onInputChange(null);
                        }
                        return value;
                    }}
                />
            </InputWrap>
        );

        return (
            <Fragment>
                {omitCollapsible ? (
                    <Fragment>{content}</Fragment>
                ) : (
                    <Collapsible
                        {...collapsibleSettings}
                        trigger={ <label className={classNamesPrefixed({"trigger__label":true})}>{label}</label>}
                        open={expanded}
                    >
                        {content}
                    </Collapsible>
                )}
            </Fragment>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        menu: state.menu,
        language: state.language
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        get: (parentWorkspaceId, language, backOffice) => dispatch(get(parentWorkspaceId, language, backOffice)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(MenuField)


// WEBPACK FOOTER //
// ./src/core/admin/components/Fields/MenuField.js